import _regeneratorRuntime from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "forget-password"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = {
  class: "form"
};
import PagePopupLayout from "@/layouts/PagePopupLayout.vue";
import { computed, ref } from "vue";
import FormItem from "./form/FormItem.vue";
import { isPhoneAccount } from "./helper";
import { watch } from "vue";
import { validCode } from "@/api/user";
import { hideLoading, showLoading } from "@/utils/loadingUtil";
import { CODE_INVALID, CODE_ERROR, INCORRECT_USERNAME } from "@/constant/responseCode";
import { Notify } from "@/utils/notifyUtil";
import Step2 from "./ForgetPasswordStep2Popup.vue";
import { useSupplierStore } from "@/store/supplierStore";
import { getSupplyId } from "@/utils/authUtil";
import { useI18n } from "vue-i18n";
export default {
  __name: 'ForgetPasswordStep1Popup',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    phone: {
      type: String,
      default: ""
    }
  },
  emits: ["update:show", "success"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var supplierStore = useSupplierStore();
    var emit = __emit;
    var isDisabled = computed(function () {
      return !formData.value.calling_code || !formData.value.phone || !formData.value.code;
    });
    var errorForm = ref({
      phone: ""
    });
    var props = __props;
    var formData = ref({
      phone: "",
      calling_code: "",
      code: ""
    });
    var showPopup = computed({
      get: function get() {
        return props.show;
      },
      set: function set(val) {
        emit("update:show", val);
      }
    });
    watch(showPopup, function (val) {
      if (!val) {
        formData.value.phone = "";
        formData.value.code = "";
      } else if (props.phone) {
        formData.value.phone = props.phone;
      }
    });
    var checkParams = function checkParams() {
      var flag = true;
      if (!isPhoneAccount(formData.value.phone, formData.value.calling_code)) {
        errorForm.value.phone = t("wrongFormatOfPhoneNumber");
        flag = false;
      }
      if (flag) {
        errorForm.value.phone = "";
      }
      return flag;
    };
    var isShowNextStep = ref(false);
    var next = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (checkParams()) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              showLoading();
              _context.next = 5;
              return validCode({
                phone: formData.value.phone,
                area_code: formData.value.calling_code,
                verification_code: formData.value.code,
                operation: "ChangePassword",
                country: supplierStore.getCountry,
                supplier_id: getSupplyId()
              });
            case 5:
              res = _context.sent;
              hideLoading();
              if (res.isOK) {
                isShowNextStep.value = true;
              } else if (res.code === CODE_INVALID || res.code === CODE_ERROR) {
                Notify.error(t("verificationCodeIsInvalid"));
              } else if (res.code === INCORRECT_USERNAME) {
                Notify.error(t("accountDoesNotExist"));
              }
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function next() {
        return _ref2.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      var _component_Gap = _resolveComponent("Gap");
      var _component_Button = _resolveComponent("Button");
      return _openBlock(), _createBlock(PagePopupLayout, {
        show: showPopup.value,
        "onUpdate:show": _cache[7] || (_cache[7] = function ($event) {
          return showPopup.value = $event;
        }),
        "content-class": "forget-container"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("forgetPassword")), 1), _createElementVNode("form", _hoisted_3, [_createVNode(FormItem, {
            callcode: formData.value.calling_code,
            "onUpdate:callcode": _cache[0] || (_cache[0] = function ($event) {
              return formData.value.calling_code = $event;
            }),
            modelValue: formData.value.phone,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return formData.value.phone = $event;
            }),
            label: _ctx.$t('phone'),
            type: "phone",
            error: errorForm.value.phone,
            onInput: _cache[2] || (_cache[2] = function ($event) {
              return errorForm.value.phone = '';
            })
          }, null, 8, ["callcode", "modelValue", "label", "error"]), _createVNode(_component_Gap, {
            h: 0.2
          }), _createVNode(FormItem, {
            modelValue: formData.value.code,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
              return formData.value.code = $event;
            }),
            phone: formData.value.phone,
            callcode: formData.value.calling_code,
            operation: "ChangePassword",
            label: _ctx.$t('vertificationCode'),
            type: "reg",
            "onPhone:error": _cache[4] || (_cache[4] = function ($event) {
              return errorForm.value.phone = _ctx.$t('wrongFormatOfPhoneNumber');
            })
          }, null, 8, ["modelValue", "phone", "callcode", "label"])]), _createVNode(_component_Button, {
            class: "btn",
            disabled: isDisabled.value,
            onClick: next
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("nextStep")), 1)];
            }),
            _: 1
          }, 8, ["disabled"]), _createVNode(Step2, {
            show: isShowNextStep.value,
            "onUpdate:show": _cache[5] || (_cache[5] = function ($event) {
              return isShowNextStep.value = $event;
            }),
            phone: formData.value.phone,
            callcode: formData.value.calling_code,
            code: formData.value.code,
            onSuccess: _cache[6] || (_cache[6] = function ($event) {
              return showPopup.value = false;
            })
          }, null, 8, ["show", "phone", "callcode", "code"])])];
        }),
        _: 1
      }, 8, ["show"]);
    };
  }
};